import mutations from './mutations';

const state = {
    navigation: {},
    pageNameMap: {},
    fileNameMap: {},
    currentPage: {}
};

export default {
    namespaced: true,
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/navigation/store.js